export { fetchTemplatePageData } from "./fetchTemplatePageData";
